/* node module imports */
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";

/* app imports */
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <div style={{ fontFamily: "Nunito Sans" }}>
      <App />
    </div>
  </React.StrictMode>
);
